'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useMemo, useState } from "react";
import { ArrowDown } from "lucide-react";
import AstroNumbers from "../ui/AstroNumbers";
export type AstroNumberItem = {
  num: string;
  title: string;
  sub: string;
};
const ASTRO_NUMBER_ITEMS: AstroNumberItem[] = [{
  num: "https://media.dinamani.com/dinamani/2026-02-27/sm2opvr2/num-1.png",
  title: "Number 1",
  sub: "பிறந்த தேதி 1, 10, 19, 28"
}, {
  num: "https://media.dinamani.com/dinamani/2026-02-27/s9dhy7mh/num-2.png",
  title: "Number 2",
  sub: "பிறந்த தேதி 2, 11, 20, 29"
}, {
  num: "https://media.dinamani.com/dinamani/2026-02-27/p1xgo570/num-3.png",
  title: "Number 3",
  sub: "பிறந்த தேதி 3, 12, 21, 30"
}, {
  num: "https://media.dinamani.com/dinamani/2026-02-27/pbi5db7w/num-4.png",
  title: "Number 4",
  sub: "பிறந்த தேதி 4, 13, 22, 31"
}, {
  num: "https://media.dinamani.com/dinamani/2026-02-27/dnnfz695/num-5.png",
  title: "Number 5",
  sub: "பிறந்த தேதி 5, 14, 23"
}, {
  num: "https://media.dinamani.com/dinamani/2026-02-27/ogfp3y1r/num-6.png",
  title: "Number 6",
  sub: "பிறந்த தேதி 6, 15, 24"
}, {
  num: "https://media.dinamani.com/dinamani/2026-02-27/jajmpkzl/num-7.png",
  title: "Number 7",
  sub: "பிறந்த தேதி 7, 16, 25"
}, {
  num: "https://media.dinamani.com/dinamani/2026-02-27/qyg5e51f/num-8.png",
  title: "Number 8",
  sub: "பிறந்த தேதி 8, 17, 26"
}, {
  num: "https://media.dinamani.com/dinamani/2026-02-27/nlk046ue/num-9.png",
  title: "Number 9",
  sub: "பிறந்த தேதி 9, 18, 27"
}];
type AstroNumbersGridProps = {
  defaultSelectedNum?: string;
  onSelect?: (item: AstroNumberItem) => void;
};
export default function AstroNumbersGrid(t0) {
  const $ = _c(14);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    defaultSelectedNum,
    onSelect
  } = t1;
  let t2;
  bb0: {
    if (!defaultSelectedNum) {
      t2 = null;
      break bb0;
    }
    let t3;
    if ($[2] !== defaultSelectedNum) {
      t3 = ASTRO_NUMBER_ITEMS.find(item => item.num === defaultSelectedNum) ?? null;
      $[2] = defaultSelectedNum;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    t2 = t3;
  }
  const initialItem = t2;
  const [selectedItem, setSelectedItem] = useState(initialItem);
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const handleAstroSelection = e => {
        const detail = e.detail;
        if (detail?.context === "numerology") {
          if (detail.clear) {
            setSelectedItem(null);
          } else {
            if (detail.num) {
              const item_0 = ASTRO_NUMBER_ITEMS.find(i => i.num === detail.num);
              if (item_0) {
                setSelectedItem(item_0);
              }
            }
          }
        }
      };
      window.addEventListener("astroNumbersSelection", handleAstroSelection as EventListener);
      return () => {
        window.removeEventListener("astroNumbersSelection", handleAstroSelection as EventListener);
      };
    };
    t4 = [];
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  if ($[6] !== onSelect) {
    t5 = item_1 => {
      setSelectedItem(item_1);
      onSelect?.(item_1);
      if (typeof window !== "undefined") {
        window.dispatchEvent(new CustomEvent("astroNumbersSelection", {
          detail: {
            ...item_1,
            context: "numerology"
          }
        }));
      }
    };
    $[6] = onSelect;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const handleSelect = t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="w-full border-b border-F2CC42 px-5"><div className="max-w-7xl mx-auto"><div className="py-2"><div className="flex items-center gap-2"><ArrowDown size={20} className="text-1B1B1B" /><p className="text-12-tamil-900 text-1B1B1B">என் ஜோதிடம்</p></div></div></div></div>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== handleSelect || $[10] !== selectedItem?.num) {
    t7 = ASTRO_NUMBER_ITEMS.map(item_2 => <button key={item_2.num} type="button" onClick={() => handleSelect(item_2)} aria-pressed={selectedItem?.num === item_2.num} className={`w-full focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-012061 rounded transition ${selectedItem?.num === item_2.num ? "bg-white/70 border border-012061/40" : "bg-transparent hover:bg-white/30 border border-transparent"}`}><AstroNumbers number={item_2.num} title={item_2.title} subtitle={item_2.sub} circleBg="#FFD54F" circleTextColor="#000" /></button>);
    $[9] = handleSelect;
    $[10] = selectedItem?.num;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <div className="bg-FFDB59 h-full"><div className="w-full max-w-7xl mx-auto bg-FFDB59 opacity-80">{t6}<div className="max-w-7xl mx-auto p-4 sm:px-6"><div className="grid gap-4 md:gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 justify-items-center w-full">{t7}</div></div></div></div>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}